import {
  AutoImage,
  AutoLink,
  Base64UploadAdapter,
  BlockQuote,
  Bold,
  ClassicEditor,
  Code,
  CodeBlock,
  Essentials,
  FileRepository,
  GeneralHtmlSupport,
  Image,
  ImageBlock,
  ImageBlockEditing,
  ImageEditing,
  ImageInsert,
  ImageResize,
  ImageUpload,
  Italic,
  Link,
  LinkUI,
  List,
  Mention,
  Paragraph,
  PictureEditing,
  SimpleUploadAdapter,
} from 'ckeditor5';
import AutoLinker from './AutoLinker';

import { CKEditor } from '@ckeditor/ckeditor5-react';

export const EDITOR_DEFAULT_CONFIG: CKEditor<ClassicEditor>['props']['config'] = {
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'bold',
      'italic',
      '|',
      'link',
      'blockQuote',
      'code',
      '|',
      'numberedList',
      'bulletedList',
      'imageUpload',
    ],
  },
  plugins: [
    Essentials,
    Bold,
    Code,
    BlockQuote,
    List,
    Italic,
    Paragraph,
    Mention,
    Link,
    Image,
    LinkUI,
    ImageBlock,
    ImageBlockEditing,
    SimpleUploadAdapter,
    ImageInsert,
    FileRepository,
    ImageUpload,
    AutoImage,
    ImageEditing,
    ImageResize,
    PictureEditing,
    ImageUpload,
    Base64UploadAdapter,
    CodeBlock,
    AutoLink,
    AutoLinker,
    GeneralHtmlSupport,
  ],

  link: {
    addTargetToExternalLinks: true,
    decorators: {
      addTargetToExternalLinks: {
        mode: 'automatic',
        callback: (url) => /^(https?:)?\/\//.test(url as string),
        attributes: {
          target: '_blank',
          rel: 'noopener noreferrer',
        },
      },
    },
  },
  htmlSupport: {
    allow: [
      {
        name: 'h5',
        attributes: true,
        classes: true,
        styles: true,
      },
    ],
  },
};
